(function () {
  if (window.__ctlCarouselInit) return;
  window.__ctlCarouselInit = true;

  function init(root) {
    if (root.dataset.ctlReady) return;
    root.dataset.ctlReady = '1';
    var track = root.querySelector('[data-ctl-track]');
    var prev = root.querySelector('[data-ctl-prev]');
    var next = root.querySelector('[data-ctl-next]');
    if (!track || !prev || !next) return;

    function step() {
      var card = track.querySelector('.ctl-carousel__card');
      if (!card) return track.clientWidth;
      var style = getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      var cardSize = card.offsetWidth + gap;
      var isMobile = window.matchMedia('(max-width: 700px)').matches;
      return cardSize * (isMobile ? 1 : 2);
    }
    function update() {
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initAll() {
    document.querySelectorAll('[data-ctl]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();